import { Icon } from "semantic-ui-react";

import "components/CircleIcons/CircleIcon.scss";
import { classNames } from "utils/common";

const CircleIconColorMap = new Map([
  ["is_star", { icon: "star", color: "green" }],
  ["is_money", { icon: "dollar sign", color: "green" }],
  ["shopping cart", { icon: "shopping cart", color: "green" }],
  ["thumb tack", { icon: "thumb tack", color: "blue" }],
  ["triangle exclamation", { icon: "triangle exclamation", color: "red" }],
  ["wrench", { icon: "wrench", color: "orange" }],
  ["fill", { icon: "fill", color: "blue" }],
  ["tire orange", { icon: "tire orange", color: "orange" }],
  ["tire green", { icon: "tire green", color: "green" }],
  ["coffee", { icon: "mug saucer", color: "cup-brown" }],
  ["is_shop", { icon: "shopping cart", color: "blue" }],
  ["shield", { icon: "shield", color: "blue" }],
  ["pin", { icon: "pin", color: "blue" }]
]);

type CircleIconProps = {
  icon: string;
  color?: string;
  disabled?: boolean;
  borderColor?: string;
  onClick?: () => void;
};

export const CircleIcon = ({ icon, disabled, onClick, color, borderColor }: CircleIconProps) => {
  const circleIconColor = CircleIconColorMap.get(icon);
  if (!circleIconColor) return null;

  const customColor = color?.startsWith("#") ? "orange" : color;

  const circleIconContainerClassNames = classNames({
    [`${circleIconColor.color}bg`]: !customColor,
    [`${customColor}bg`]: !!customColor,
    [`${borderColor}-border`]: !!borderColor,
    disabled: disabled
  });

  const iconClassNames = classNames({
    [circleIconColor.color]: !customColor,
    [`${customColor}`]: !!customColor
  });

  return (
    <div className="circle-icon-container" onClick={onClick}>
      <div className={`circle-icon ${circleIconContainerClassNames}`}>
        <Icon className={`${circleIconColor.icon} ${iconClassNames}`} size="small" />
      </div>
    </div>
  );
};
